import React from 'react'
import styled from 'react-emotion'

const BlockVideo = styled(({ block, className }) => (
  <video className={className} controls src={block.video} />
))({
  label: 'BlockVideo',
  width: '100%',
  height: '100%'
})

export default BlockVideo
